/**
 * Node modules
 */
import VendorAntToaster from 'antd/lib/message';

VendorAntToaster.displayName = 'VendorAntToaster';
export default VendorAntToaster;
